/* eslint-disable sort-keys */
import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { withPrefix } from 'gatsby'
import Helmet from 'react-helmet'
import { version } from '~package.json'

import useSiteMeta from '~2021/hooks/useSiteMeta'

const getSocialTitle = (title, isFandom) => {
  if (isFandom) {
    return `${title} Fandom | Biggest Fandoms in the World 2021 | FanSided`
  }

  if ('home' === title.toLowerCase()) {
    return 'Biggest Fandoms in the World 2021 | FanSided Fandoms of the Year'
  }

  if ('404: not found' === title.toLowerCase()) {
    return `${title} | Biggest Fandoms in the World 2021 | FanSided`
  }

  //   Category
  return `${title} Fandoms | Biggest Fandoms in the World 2021 | FanSided`
}

export const getTwitterDescription = (isFandom, twitterFandomTitle) =>
  isFandom
    ? `${twitterFandomTitle}made the #FandomsOfTheYear from @FanSided. Did your favorite fandom make the list?`
    : `Did your favorite fandom make the #FandomsOfTheYear from @FanSided?`

export const getFBDescription = (isFandom, detailFandomTitle) =>
  isFandom
    ? `${detailFandomTitle} made the Fandoms of the Year from FanSided. Did your favorite fandom make the list?`
    : `Did your favorite fandom make the Fandoms of the Year from FanSided?`

const Seo = ({
  description,
  lang,
  meta,
  title,
  page,
  detailFandomTitle,
  detailImage,
  path,
  twitterHandle,
  isFandom,
}) => {
  const siteMeta = useSiteMeta()
  const filterSelector = (state) => state.filter

  const { siteUrl } = siteMeta

  const getShareUrl = () => {
    let url = siteUrl
    if (path) {
      if (path.includes('fandoms-of-the-year')) {
        url = `${siteUrl.replace('/fandoms-of-the-year', '')}${path}`
      } else {
        url = `${siteUrl}${path}`
      }
    }
    url = url.match(/\/$/) ? url : url + '/'

    return url
  }

  const {
    default: { year: defaultYear },
  } = useSelector(filterSelector)

  const socialTitle = getSocialTitle(title, isFandom)

  const socialImage =
    siteUrl.replace('/fandoms-of-the-year', '') +
    (detailImage
      ? withPrefix(detailImage.replace('_original', 'desktop'))
      : withPrefix(`/images/${defaultYear}/socialShareImg.png`)) +
    `?=${version}`

  const metaDescription = description || siteMeta.description

  const twitterFandomTitle =
    detailFandomTitle &&
    twitterHandle &&
    detailFandomTitle.split(' ').join('') === twitterHandle.slice(1)
      ? twitterHandle + ' '
      : detailFandomTitle + ' '

  const twitterDescription = getTwitterDescription(isFandom, twitterFandomTitle)
  const fbDescription = getFBDescription(isFandom, twitterFandomTitle)

  return (
    <Helmet
      htmlAttributes={{
        lang,
        class: '404' === page ? 'is404' : '',
      }}
      meta={[
        {
          name: 'description',
          content: metaDescription,
        },
        {
          property: 'og:title',
          content: socialTitle,
        },
        {
          property: 'og:description',
          content: fbDescription,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: 'og:url',
          content: getShareUrl(),
        },
        {
          property: 'og:image',
          content: socialImage,
        },
        {
          property: 'og:image:alt',
          content: 'Fandoms of the Year',
        },
        {
          property: 'og:image:width',
          content: '1200',
        },
        {
          property: 'og:image:height',
          content: '630',
        },
        {
          property: 'fb:app_id',
          content: '531030426978426',
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'twitter:creator',
          content: siteMeta.author,
        },
        {
          name: 'twitter:title',
          content: socialTitle,
        },
        {
          name: 'twitter:site',
          content: '@FanSided',
        },
        {
          name: 'twitter:description',
          content: twitterDescription,
        },
        {
          name: 'twitter:image',
          content: socialImage,
        },
        {
          name: 'twitter:image:alt',
          content: 'Fandoms of the Year',
        },
      ].concat(meta)}
      title={socialTitle}
      //   titleTemplate={
      //     'Home' === title ? `${siteMeta.title}` : `%s | ${siteMeta.abrvTitle}`
      //   }
    />
  )
}

Seo.defaultProps = {
  lang: 'en',
  meta: [],
  description: '',
  page: '',
  isFandom: false,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  page: PropTypes.string,
  isFandom: PropTypes.bool,
}

export default Seo
